import RCPagination, {
  PaginationProps as RCPaginationProps
} from 'rc-pagination'
import { IoEllipsisHorizontal } from 'react-icons/io5'
import { MdOutlineNavigateNext, MdOutlineNavigateBefore } from 'react-icons/md'

const LOCALE = {
  // Options.jsx
  page: 'Page',

  // Pagination.jsx
  prev_page: 'Previous page',
  next_page: 'Next page'
}

export interface PaginationProps {
  count: number
  onChange: RCPaginationProps['onChange']
  page: number
  pageSize: number
}

export const Pagination = ({
  count,
  page,
  pageSize,
  onChange
}: PaginationProps) => {
  return count && page && pageSize ? (
    <div className='my-6'>
      <RCPagination
        current={page}
        jumpNextIcon={<IoEllipsisHorizontal />}
        jumpPrevIcon={<IoEllipsisHorizontal />}
        locale={LOCALE}
        nextIcon={<MdOutlineNavigateNext />}
        onChange={onChange}
        pageSize={pageSize}
        prevIcon={<MdOutlineNavigateBefore />}
        total={count}
      />
    </div>
  ) : null
}
